// apiHelper.js
import { toast } from "react-toastify"
import axios from "axios"
import { API_URL } from "./constants"

const responseToFa = {
    INTERNALE_SERVER_ERROR: "خطای داخلی",
    INSUFFICIENT_BALANCE: "موجودی کافی نیست",
}

// Create axios instance with default config
const apiClient = axios.create({
    baseURL: API_URL + "/api",
    timeout: 20000,
})

// Request interceptor to add token
export const initializeToken = (token) =>
    apiClient.interceptors.request.use(
        (config) => {
            config.headers.Authorization = `Bearer ${token}`

            return config
        },
        (error) => {
            return Promise.reject(error)
        }
    )

// Response interceptor for error handling
apiClient.interceptors.response.use(
    (response) => {
        // You can transform response data here
        return response
    },
    (error) => {
        if (error.response) {
            const { status, data } = error.response
            const errorMessage = data || data?.message || "مشکلی به وجود آمده است"
            console.log(error)
            // Handle specific status codes
            switch (status) {
                case 403:
                    toast.error(responseToFa[errorMessage] || "دسترسی غیر مجاز")
                    break
                case 404:
                    toast.error(responseToFa[errorMessage] || "منبع مورد نظر یافت نشد")
                    break
                case 500:
                    toast.error(responseToFa[errorMessage] || "خطای سرور")
                    break
                default:
                    toast.error(responseToFa[errorMessage])
            }
        } else if (error.request) {
            toast.error("خطا در اتصال به سرور")
        } else {
            toast.error("خطای ناشناخته")
        }

        return Promise.reject(error)
    }
)

// Main API helper function
const apiHelper = {
    // Shorthand methods
    get: (path, config = {}) => apiClient.get(path, config),
    post: (path, data, config = {}) => apiClient.post(path, data, config),
    put: (path, data, config = {}) => apiClient.put(path, data, config),
    patch: (path, data, config = {}) => apiClient.patch(path, data, config),
    delete: (path, config = {}) => apiClient.delete(path, config),

    // Upload method with progress
    upload: (path, formData, onProgress) => {
        return apiClient.post(path, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
            onUploadProgress: onProgress,
        })
    },

    // Custom request method (like your original)
    request: (config) => apiClient.request(config),
}

export default apiHelper
